import { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import InstallBanner from './components/InstallBanner';
import AutoClassifierPage from './pages/AutoClassifierPage';
import CentroidPage from './pages/CentroidPage';
import ClassifierApplyPage from './pages/ClassifierApplyPage';
import ClassifierCreatePage from './pages/ClassifierCreatePage';
import FilterApplyPage from './pages/FilterApplyPage';
import FilterCreatePage from './pages/FilterCreatePage';
import HeadlinesPage from './pages/HeadlinesPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import SearchPage from './pages/SearchPage';
import SettingsPage from './pages/SettingsPage';
import { useAuthStore } from './stores/authStore';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user);
  const checked = useAuthStore((s) => s.checked);
  if (!checked) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function RedirectHome() {
  return <Navigate to="/all" replace />;
}

export default function App() {
  const checkAuth = useAuthStore((s) => s.checkAuth);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <BrowserRouter>
      <InstallBanner />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route
          path="/all"
          element={
            <RequireAuth>
              <HeadlinesPage />
            </RequireAuth>
          }
        />
        <Route
          path="/source/:slug"
          element={
            <RequireAuth>
              <HeadlinesPage />
            </RequireAuth>
          }
        />
        <Route
          path="/classifier/:classifierId"
          element={
            <RequireAuth>
              <HeadlinesPage />
            </RequireAuth>
          }
        />
        <Route
          path="/search"
          element={
            <RequireAuth>
              <SearchPage />
            </RequireAuth>
          }
        />
        <Route
          path="/centroid"
          element={
            <RequireAuth>
              <CentroidPage />
            </RequireAuth>
          }
        />
        <Route
          path="/classifiers"
          element={
            <RequireAuth>
              <ClassifierApplyPage />
            </RequireAuth>
          }
        />
        <Route
          path="/classifiers/new"
          element={
            <RequireAuth>
              <ClassifierCreatePage />
            </RequireAuth>
          }
        />
        <Route
          path="/classifiers/auto"
          element={
            <RequireAuth>
              <AutoClassifierPage />
            </RequireAuth>
          }
        />
        <Route
          path="/filters"
          element={
            <RequireAuth>
              <FilterApplyPage />
            </RequireAuth>
          }
        />
        <Route
          path="/filters/new"
          element={
            <RequireAuth>
              <FilterCreatePage />
            </RequireAuth>
          }
        />
        <Route
          path="/settings"
          element={
            <RequireAuth>
              <SettingsPage />
            </RequireAuth>
          }
        />
        <Route
          path="/"
          element={
            <RequireAuth>
              <RedirectHome />
            </RequireAuth>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
